import { Locales, TLocale } from 'src/lib/constants';
import { NAVIGATION_EVENTS } from 'src/lib/trackingEvents';
import type { NavData } from './types';

const enEU: NavData = {
  items: [
    {
      id: 'main-menu-item-002',
      type: 'tabs',
      title: 'Products',
      children: [
        {
          id: 'main-menu-item-012',
          type: 'list',
          title: 'Payments',
          children: [
            {
              title: 'Overview',
              description: 'Explore payments solutions',
              href: '/solutions/payments/',
              icon: 'Income',
              isOverview: true,
            },
            {
              title: 'Pay By Bank',
              description: 'Instant bank payments',
              href: '/products/payment-initiation/',
              icon: 'Institution',
            },
          ],
        },
        {
          id: 'main-menu-item-022',
          type: 'list',
          title: 'Credit underwriting',
          children: [
            {
              title: 'Overview',
              description: 'Explore credit underwriting insight solutions',
              href: '/industries/consumer-lending/',
              icon: 'Clipboard',
              isOverview: true,
            },
            {
              title: 'Income',
              description: 'Real-time, forward-looking income data',
              href: '/products/income/',
              icon: 'Login',
            },
            {
              title: 'Transactions',
              description: '2 years of categorised transaction data',
              href: '/products/transactions/',
              icon: 'PieChart',
            },
          ],
        },
        {
          id: 'main-menu-item-032',
          type: 'list',
          title: 'Onboarding',
          children: [
            {
              title: 'Link',
              description:
                'Industry-leading bank connections for 12,000+ institutions',
              href: '/plaid-link/',
              icon: 'Integrations',
            },
            {
              title: 'Auth',
              description: 'Verified account and routing numbers',
              href: '/products/auth/',
              icon: 'Institution',
            },
            {
              title: 'Identity',
              description: 'Bank account-holder information',
              href: '/products/identity/',
              icon: 'Identity',
            },
          ],
        },
        {
          id: 'main-menu-item-042',
          type: 'list',
          title: 'Financial management',
          children: [
            {
              title: 'Overview',
              description: 'Explore personal finance insights solutions',
              href: '/solutions/personal-financial-management/',
              icon: 'Guide',
              isOverview: true,
            },
            {
              title: 'Transactions for financial management',
              description: 'Detailed transaction insights',
              href: '/products/transactions/',
              icon: 'ProductTransactions',
            },
          ],
        },
      ],
    },
    {
      id: 'main-menu-item-003',
      type: 'list',
      title: 'Use cases',
      children: [
        {
          title: 'Lending & underwriting',
          href: '/industries/consumer-lending/',
          icon: 'Income',
        },
        {
          title: 'Payments',
          href: '/solutions/payments/',
          icon: 'Wallet',
        },
        {
          title: 'Property management',
          href: '/plaid-for-property-management/',
          icon: 'Home',
        },
        {
          title: 'Banking & wealth',
          href: '/use-cases/banking-and-wealth/',
          icon: 'Institution',
        },
        {
          title: 'iGaming',
          href: '/use-cases/igaming/',
          icon: 'Dice',
        },
        {
          title: 'Personal finance management',
          href: '/solutions/personal-financial-management/',
          icon: 'PieChart',
        },
        {
          title: 'Business financial management',
          href: '/use-cases/business-financial-management/',
          icon: 'Buildings',
        },
      ],
    },
    {
      id: 'main-menu-item-005',
      type: 'list',
      title: 'Developers',
      children: [
        {
          title: 'Quickstart',
          href: '/docs/quickstart/',
          icon: 'ChevronRightDouble',
          locale: Locales.EN_US,
        },
        {
          title: 'API documentation',
          href: '/docs/',
          icon: 'Docs',
          locale: Locales.EN_US,
        },
        {
          title: 'Libraries',
          href: '/docs/api/libraries/',
          icon: 'Libraries',
          locale: Locales.EN_US,
        },
        {
          title: 'GitHub',
          href: 'https://github.com/plaid',
          icon: 'Webhooks',
        },
      ],
    },
    {
      id: 'main-menu-item-006',
      type: 'columns',
      title: 'Resources',
      children: [
        {
          title: 'For builders',
          children: [
            {
              title: 'Customer stories',
              href: '/customer-stories/',
              icon: 'Message',
            },
            {
              title: 'Global coverage',
              href: '/global/',
              icon: 'Webhooks',
            },
            {
              title: 'Company',
              href: '/company/',
              icon: 'Buildings',
            },
            {
              title: 'Industry resources',
              href: '/resources/',
              icon: 'Guide',
              locale: Locales.EN_US,
            },
            {
              title: 'Blog',
              href: '/blog/',
              icon: 'Notebook',
              locale: Locales.EN_US,
            },
            {
              title: 'Contact',
              href: '/contact/',
              icon: 'Mail',
            },
            {
              title: 'What is Plaid',
              href: '/what-is-plaid/',
              icon: 'PlaidLogo',
            },
          ],
        },
        {
          title: 'For users',
          children: [
            {
              title: 'Safety',
              href: '/safety/',
            },
            {
              title: 'How we handle data',
              href: '/how-we-handle-data/',
            },
            {
              title: 'Legal',
              href: '/legal/#consumers',
              locale: Locales.EN_US,
            },
          ],
        },
      ],
    },
    {
      id: 'main-menu-item-004',
      title: 'Pricing',
      href: '/pricing/',
      trackingId: NAVIGATION_EVENTS.PRIMARY.USER_CLICKED_PRIMARY_NAV_PRICING,
    },
  ],
  ctaTrackingIds: {
    getAPIkeys: NAVIGATION_EVENTS.PRIMARY.GET_API_KEYS_BUTTON,
  },
};

const enGB: NavData = {
  items: [
    {
      id: 'main-menu-item-002',
      type: 'tabs',
      title: 'Products',
      children: [
        {
          id: 'main-menu-item-012',
          type: 'list',
          title: 'Payments',
          children: [
            {
              title: 'Overview',
              description: 'Explore payments solutions',
              href: '/solutions/payments/',
              icon: 'Income',
              isOverview: true,
            },
            {
              title: 'Pay By Bank',
              description: 'Instant bank payments',
              href: '/products/payment-initiation/',
              icon: 'Institution',
            },
            {
              title: 'Recurring Payments',
              description:
                'Enable your users to make flexible recurring payments',
              href: '/products/variable-recurring-payments/',
              icon: 'Refresh',
            },
            {
              title: 'Payouts',
              description: 'Seamless payouts within your app',
              href: '/products/payouts/',
              icon: 'ArrowRight',
            },
          ],
        },
        {
          id: 'main-menu-item-022',
          type: 'list',
          title: 'Credit underwriting',
          children: [
            {
              title: 'Overview',
              description: 'Explore credit underwriting insights solutions',
              href: '/industries/consumer-lending/',
              icon: 'Clipboard',
              isOverview: true,
            },
            {
              title: 'Income',
              description: 'Real-time, forward-looking income data',
              href: '/products/income/',
              icon: 'Login',
            },
            {
              title: 'Transactions',
              description: '2 years of categorised transaction data',
              href: '/products/transactions/',
              icon: 'PieChart',
            },
            {
              title: 'Loan Disbursement',
              description: 'Instant bank-account loan payouts',
              href: '/products/payouts/',
              icon: 'Income',
            },
            {
              title: 'Loan Repayments',
              description: 'Faster VRP loan collections',
              href: '/products/variable-recurring-payments/',
              icon: 'Safe',
            },
          ],
        },
        {
          id: 'main-menu-item-032',
          type: 'list',
          title: 'Onboarding',
          children: [
            {
              title: 'Link',
              description:
                'Industry-leading bank connections for 12,000+ institutions',
              href: '/plaid-link/',
              icon: 'Integrations',
            },
            {
              title: 'Auth',
              description: 'Verified account and routing numbers',
              href: '/products/auth/',
              icon: 'Institution',
            },
            {
              title: 'Identity Verification',
              description: 'Global KYC and anti-fraud',
              href: '/products/identity-verification/',
              icon: 'ProductIdv',
            },
            {
              title: 'Identity',
              description: 'Bank account-holder information',
              href: '/products/identity/',
              icon: 'Identity',
            },
            {
              title: 'Monitor',
              description: 'AML and PEP screening',
              href: '/products/monitor/',
              icon: 'ProductMonitor',
            },
          ],
        },
        {
          id: 'main-menu-item-042',
          type: 'list',
          title: 'Financial management',
          children: [
            {
              title: 'Overview',
              description: 'Explore personal finance insights solutions',
              href: '/solutions/personal-financial-management/',
              icon: 'Guide',
              isOverview: true,
            },
            {
              title: 'Transactions for financial management',
              description: 'Detailed transaction insights',
              href: '/products/transactions/',
              icon: 'ProductTransactions',
            },
          ],
        },
      ],
    },
    {
      id: 'main-menu-item-003',
      type: 'list',
      title: 'Use cases',
      children: [
        {
          title: 'Lending & underwriting',
          href: '/industries/consumer-lending/',
          icon: 'Income',
        },
        {
          title: 'Payments',
          href: '/solutions/payments/',
          icon: 'Wallet',
        },
        {
          title: 'Recurring payments',
          href: '/products/variable-recurring-payments/',
          icon: 'Tag',
        },
        {
          title: 'Property management',
          href: '/plaid-for-property-management/',
          icon: 'Home',
        },
        {
          title: 'Banking & wealth',
          href: '/use-cases/banking-and-wealth/',
          icon: 'Institution',
        },
        {
          title: 'Crypto',
          href: '/cryptocurrency-solutions/',
          icon: 'Globe',
        },
        {
          title: 'iGaming',
          href: '/use-cases/igaming/',
          icon: 'Dice',
        },
        {
          title: 'Personal finance management',
          href: '/solutions/personal-financial-management/',
          icon: 'PieChart',
        },
        {
          title: 'Business financial management',
          href: '/use-cases/business-financial-management/',
          icon: 'Buildings',
        },
      ],
    },
    {
      id: 'main-menu-item-005',
      type: 'list',
      title: 'Developers',
      children: [
        {
          title: 'Quickstart',
          href: '/docs/quickstart/',
          icon: 'ChevronRightDouble',
          locale: Locales.EN_US,
        },
        {
          title: 'API documentation',
          href: '/docs/',
          icon: 'Docs',
          locale: Locales.EN_US,
        },
        {
          title: 'Libraries',
          href: '/docs/api/libraries/',
          icon: 'Libraries',
          locale: Locales.EN_US,
        },
        {
          title: 'GitHub',
          href: 'https://github.com/plaid',
          icon: 'Webhooks',
        },
      ],
    },
    {
      id: 'main-menu-item-006',
      type: 'columns',
      title: 'Resources',
      children: [
        {
          title: 'For builders',
          children: [
            {
              title: 'Customer stories',
              href: '/customer-stories/',
              icon: 'Message',
            },
            {
              title: 'Global coverage',
              href: '/global/',
              icon: 'Webhooks',
            },
            {
              title: 'Blog',
              href: '/blog/',
              icon: 'Notebook',
              locale: Locales.EN_US,
            },
            {
              title: 'Company',
              href: '/company/',
              icon: 'Buildings',
            },
            {
              title: 'Contact',
              href: '/contact/',
              icon: 'Mail',
            },
            {
              title: 'What is Plaid',
              href: '/what-is-plaid/',
              icon: 'PlaidLogo',
            },
          ],
        },
        {
          title: 'For users',
          children: [
            {
              title: 'Safety',
              href: '/safety/',
            },
            {
              title: 'How we handle data',
              href: '/how-we-handle-data/',
            },
            {
              title: 'Legal',
              href: '/legal/#consumers',
              locale: Locales.EN_US,
            },
          ],
        },
      ],
    },
    {
      id: 'main-menu-item-004',
      title: 'Pricing',
      href: '/pricing/',
      trackingId: NAVIGATION_EVENTS.PRIMARY.USER_CLICKED_PRIMARY_NAV_PRICING,
    },
  ],
  ctaTrackingIds: {
    getAPIkeys: NAVIGATION_EVENTS.PRIMARY.GET_API_KEYS_BUTTON,
  },
};

const enUS: NavData = {
  items: [
    {
      id: 'main-menu-item-002',
      type: 'tabs',
      title: 'Products',
      children: [
        {
          id: 'main-menu-item-012',
          type: 'list',
          title: 'Payments',
          children: [
            {
              title: 'Overview',
              description: 'Explore payments solutions',
              href: '/solutions/payments/',
              icon: 'Income',
              isOverview: true,
            },
            {
              title: 'Auth',
              description: 'Verified account and routing numbers',
              href: '/products/auth/',
              icon: 'Institution',
            },
            {
              title: 'Identity',
              description: 'Bank account-holder information',
              href: '/products/identity/',
              icon: 'Identity',
            },
            {
              title: 'Balance',
              description: 'Real-time balance checks',
              href: '/products/balance/',
              icon: 'LineGraph',
            },
            {
              title: 'Signal',
              description: 'ACH payment risk platform',
              href: '/products/signal/',
              icon: 'Shield',
            },
            {
              title: 'Transfer',
              description: 'ACH, RTP, and FedNow payment processing',
              href: '/products/transfer/',
              icon: 'Transfer',
            },
            {
              title: 'Investments Move',
              description: 'Streamline asset transfers. Unlock growth.',
              href: '/products/investments-move/',
              icon: 'ChevronRightDouble',
            },
          ],
        },
        {
          id: 'main-menu-item-022',
          type: 'list',
          title: 'Fraud & risk',
          children: [
            {
              title: 'Overview',
              description: 'Explore fraud and risk solution',
              href: '/solutions/fraud/',
              icon: 'ItemManagement',
              isOverview: true,
            },
            {
              title: 'Identity Verification',
              description: 'Global KYC and anti-fraud',
              href: '/products/identity-verification/',
              icon: 'ProductIdv',
            },
            {
              title: 'Beacon',
              description: 'Anti-fraud network',
              href: '/products/beacon/',
              icon: 'ProductBeacon',
            },
            {
              title: 'Monitor',
              description: 'AML watchlist screening',
              href: '/products/monitor/',
              icon: 'ProductMonitor',
            },
            {
              title: 'Signal',
              description: 'ACH payment risk platform',
              href: '/products/signal/',
              icon: 'Shield',
            },
            {
              title: 'Identity',
              description: 'Bank account-holder information',
              href: '/products/identity/',
              icon: 'Identity',
            },
            {
              title: 'Protect',
              description: 'Fraud intelligence system',
              href: '/products/protect/',
              icon: 'ProductProtect',
            },
          ],
        },
        {
          id: 'main-menu-item-032',
          type: 'list',
          title: 'Personal finance insights',
          children: [
            {
              title: 'Overview',
              description: 'Explore the personal finance insights solution',
              href: '/solutions/personal-financial-management/',
              icon: 'Guide',
              isOverview: true,
            },
            {
              title: 'Transactions',
              description: 'Up to 24 months of categorized data',
              href: '/products/transactions/',
              icon: 'ProductTransactions',
            },
            {
              title: 'Investments',
              description: 'Retirement, brokerage, and crypto data',
              href: '/products/investments/',
              icon: 'LineGraph',
            },
            {
              title: 'Liabilities',
              description: 'Credit card and mortgage data',
              href: '/products/liabilities/',
              icon: 'BarGraph',
            },
            {
              title: 'Enrich',
              description: 'Cleanse and categorize internal transactions',
              href: '/products/enrich/',
              icon: 'Tag',
            },
          ],
        },
        {
          id: 'main-menu-item-042',
          type: 'list',
          title: 'Credit underwriting',
          children: [
            {
              title: 'Overview',
              description: 'Explore our credit underwriting solutions',
              href: '/industries/consumer-lending/',
              icon: 'Clipboard',
              isOverview: true,
            },
            {
              title: 'Income & Underwriting',
              description: 'Credit risk insights powered by Plaid Check',
              href: '/check/income-and-underwriting/',
              icon: 'Wallet',
            },
            {
              title: 'LendScore',
              description: 'A credit risk score powered by unique insights',
              href: '/check/lendscore/',
              icon: 'Progress',
            },
          ],
        },
        {
          id: 'main-menu-item-052',
          type: 'list',
          title: 'Open finance',
          children: [
            {
              title: 'Overview',
              description: 'Explore open finance solution',
              href: '/use-cases/open-finance/',
              icon: 'Institution',
              isOverview: true,
            },
            {
              title: 'Core Exchange',
              description: 'Industry-aligned API connectivity',
              href: '/products/core-exchange/',
              icon: 'Globe',
            },
            {
              title: 'Permissions Manager',
              description: 'Embeddable consumer permissions management',
              href: '/products/permissions-manager/',
              icon: 'Users',
            },
            {
              title: 'App Directory',
              description: 'App insights to help manage risk and compliance',
              href: '/products/app-directory/',
              icon: 'Mobile',
            },
          ],
        },
        {
          id: 'main-menu-item-062',
          type: 'list',
          title: 'Onboarding',
          children: [
            {
              title: 'Overview',
              description: 'Explore onboarding solutions',
              href: '/solutions/onboarding/',
              icon: 'Guide',
              isOverview: true,
            },
            // TODO: add description and icon to these on mobile
            {
              title: 'Link',
              href: '/plaid-link/',
              description:
                'Industry-leading bank connections for 12,000+ institutions',
              image: 'link',
              icon: 'Link',
              imagePos: 'bottom',
            },
            {
              title: 'Layer',
              href: '/layer/',
              description:
                'Capture identity, contact and bank info in a single click.  ',
              image: 'layer',
              icon: 'Platform',
              imagePos: 'top',
            },
          ],
        },
      ],
    },
    {
      id: 'main-menu-item-003',
      type: 'columnsWithCardWIcons',
      title: 'Solutions',
      children: [
        {
          title: 'Use cases',
          children: [
            {
              title: 'Open finance',
              href: '/use-cases/open-finance/',
              icon: 'Globe',
            },
            {
              title: 'Fraud & risk prevention',
              href: '/use-cases/fraud-and-risk-prevention/',
              icon: 'Shield',
            },
            {
              title: 'Onboarding & identity verification',
              href: '/use-cases/instant-onboarding-identity-verification/',
              icon: 'ProductIdv',
            },
            {
              title: 'KYC & AML compliance',
              href: '/use-cases/kyc-aml-compliance/',
              icon: 'Users',
            },
            {
              title: 'Income verification & underwriting',
              href: '/check/income-and-underwriting/',
              icon: 'Wallet',
            },
            {
              title: 'Inbound bank payments',
              href: '/use-cases/inbound-bank-payments/',
              icon: 'Login',
            },
            {
              title: 'Outbound bank payments',
              href: '/use-cases/outbound-bank-payments/',
              icon: 'Logout',
            },
            {
              title: 'Personal financial management',
              href: '/use-cases/personal-financial-insights/',
              icon: 'Guide',
            },
            {
              title: 'Business financial management',
              href: '/use-cases/business-financial-management/',
              icon: 'LineGraph',
            },
            {
              title: 'Earned wage access',
              href: '/use-cases/earned-wage-access/',
              icon: 'Income',
            },
          ],
        },
        {
          title: 'Industries',
          children: [
            {
              title: 'AI companies',
              href: '/industries/ai/',
              icon: 'Ai',
            },
            {
              title: 'Auto',
              href: '/industries/auto/',
              icon: 'Gear',
            },
            {
              title: 'Banks & credit unions',
              href: '/industries/banks-credit-unions/',
              icon: 'Institution',
            },
            {
              title: 'Billing & recurring payments',
              href: '/industries/billing-recurring-payments/',
              icon: 'Refresh',
            },
            {
              title: 'Consumer lending',
              href: '/industries/consumer-lending/',
              icon: 'Clipboard',
            },
            {
              title: 'Gaming',
              href: '/industries/gaming/',
              icon: 'Dice',
            },
            {
              title: 'Government & public sector',
              href: '/industries/government-public-sector/',
              icon: 'Buildings',
            },
            {
              title: 'Healthcare',
              href: '/industries/healthcare/',
              icon: 'Healthcare',
            },
            {
              title: 'Insurance',
              href: '/industries/insurance/',
              icon: 'Insurance',
            },
            {
              title: 'Mortgage',
              href: '/industries/mortgage/',
              icon: 'Key',
            },
            {
              title: 'Platforms & marketplaces',
              href: '/industries/platforms-marketplaces/',
              icon: 'Platform',
            },
            {
              title: 'Property management',
              href: '/industries/property-management/',
              icon: 'Home',
            },
          ],
        },
      ],
    },
    {
      id: 'main-menu-item-005',
      type: 'list',
      title: 'Developers',
      children: [
        {
          title: 'Quickstart',
          href: '/docs/quickstart/',
          icon: 'ChevronRightDouble',
        },
        {
          title: 'API documentation',
          href: '/docs/',
          icon: 'Docs',
        },
        {
          title: 'Libraries',
          href: '/docs/api/libraries/',
          icon: 'Libraries',
        },
        {
          title: 'GitHub',
          href: 'https://github.com/plaid',
          icon: 'Webhooks',
        },
        {
          title: 'Product demos',
          href: '/demo/',
          icon: 'Mobile',
        },
      ],
    },
    {
      id: 'main-menu-item-006',
      type: 'columns',
      title: 'Resources',
      children: [
        {
          title: 'For builders',
          children: [
            {
              title: "What's new",
              href: '/whats-new/',
              icon: 'Guide',
            },
            {
              title: 'Blog',
              href: '/blog/',
              icon: 'Notebook',
            },
            {
              title: 'Library',
              href: '/resources/library/',
              icon: 'Libraries',
            },
            {
              title: 'Industry resources',
              href: '/resources/',
              icon: 'NewWindow',
            },
            {
              title: 'Customer stories',
              href: '/customer-stories/',
              icon: 'Message',
            },
            {
              title: 'Events',
              href: '/events/',
              icon: 'Calendar',
            },
            {
              title: 'Annual conference',
              href: '/events/effects/',
              icon: 'Video',
            },
            {
              title: 'What is Plaid',
              href: '/what-is-plaid/',
              icon: 'PlaidLogo',
            },
            {
              title: 'Intelligent finance',
              href: '/intelligent-finance/',
              icon: 'Lightbulb',
            },
          ],
        },
        {
          title: 'For users',
          children: [
            {
              title: 'Troubleshoot account connection',
              href: '/trouble-connecting/',
            },
            {
              title: 'Trust and safety',
              href: '/trust-safety/',
            },
            {
              title: 'Control your data with Plaid Portal',
              href: '//my.plaid.com/',
            },
            {
              title: 'Plaid Check Consumer Help Center',
              href: '/check/consumer-service-center/',
            },
          ],
        },
      ],
    },
    {
      id: 'main-menu-item-004',
      title: 'Pricing',
      href: '/pricing/',
      trackingId: NAVIGATION_EVENTS.PRIMARY.USER_CLICKED_PRIMARY_NAV_PRICING,
    },
  ],
  ctaTrackingIds: {
    getAPIkeys: NAVIGATION_EVENTS.PRIMARY.GET_API_KEYS_BUTTON,
  },
};

export const navData: Record<TLocale, NavData> = {
  'en-eu': enEU,
  'en-gb': enGB,
  'en-us': enUS,
};
